import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit'
import $api from '../api'
import { GetListDTO } from '../dto'
import { User } from './usersSlice'
import { attemptCreatePlaylist, Playlist } from './playlistsSlice'

interface OrderPlaylistDto {
  businessName: User['name']
  activityType: string
  address: string
  males: string
  females: string
  age18_30: string
  age31_45: string
  age46_60: string
  vocalToInstrumental: string
  internationalToLocal: string
  extraClarifications: string
  linkTracksExamples: string
  styles: MusicGenre[]
}

export type Order = OrderPlaylistDto & {
  _id: string
  playlists?: Playlist[]
  createdAt: number
}

type OrderId = string


export enum MusicGenre {
  PopMusic = 'pop_music',
  LoungeMusic = 'lounge_music',
  JazzMusic = 'jazz_music',
  ClassicMusic = 'classic_music',
  RockMusic = 'rock_music',
  HipHopMusic = 'hiphop_music',
  ElectronicMusic = 'electronic_music',
}

export enum OrderPlaylistOrderBy {
  BUSINESS_NAME = 'businessName',
}

interface ListPlaylistOrdersDto extends GetListDTO {
  oderBy?: OrderPlaylistOrderBy
}

interface State {
  orders: Record<OrderId, Order>
}

export const initialState: State = {
  orders: {},
}

export const attemptGetAllOrders = createAsyncThunk<Order[], ListPlaylistOrdersDto>(
  'orders/get-all',
  async (payload) => {
    const response = await $api.post(`order/admin/list`, payload)
    console.log('attemptGetAllOrders response.data:', response.data)
    return response.data
  },
)

export const attemptGetOrder = createAsyncThunk<Order, string>(
  'orders/get',
  async (id) => {
    const response = await $api.get(`order/${id}`)
    console.log('attemptGetOrder response.data:', response.data)
    return response.data
  },
)

export const ordersReducer = createSlice({
  name: 'orders',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(attemptGetAllOrders.fulfilled, (state, { payload }) => {
      // state.businesses[payload._id] = payload //don't need it as we are always fetching businesses when coming to the page
      payload.forEach((order) => {
        state.orders[order._id] = order
      })
    })
    builder.addCase(attemptGetOrder.fulfilled, (state, action) => {
      state.orders[action.meta.arg] = action.payload
    })
    builder.addCase(attemptCreatePlaylist.fulfilled, (state, { payload }) => {
      console.log('attemptCreatePlaylist fulfilled payload:', payload)
      const id = payload.userOrder
      if (id && state.orders[id]) {
        state.orders[id].playlists = [
          ...(state.orders[id].playlists || []),
          payload,
        ]
      }
    })
  },
})

export const {} = ordersReducer.actions
export default ordersReducer.reducer
